// extracted by css-extract-rspack-plugin
export default {"truncate":"truncate-t3qHA6","tabular":"tabular-FQrqws","mono":"mono-LcK1eo text-xs","empty":"empty-QUnYaz","warning":"warning-sHvier","danger":"danger-JSK1Bq"};